import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapCardZoom = (function ($) {

    let root  = document.documentElement;
    let body  = document.body;
    let cardsFullscreen = document.querySelectorAll(".js-card-zoom-fullscreen");
    let cards = document.querySelectorAll(".js-card-zoom");

    function init() {

        for (let i = 0; i < cards.length; i++) {
            addListeners(cards[i], cardsFullscreen[i]);
        }

        function addListeners(card, cardFullscreen) {

            card.addEventListener("click", function() {
                card.classList.add('card-visible');
                cardFullscreen.classList.add('card-fullscreen-visible');
                animateFullscreen(card, cardFullscreen);
                // setTimeout(() => {
                //     root.classList.add('no-overflow'); // with this the page is slightly resized and the header menu is shown
                // }, 500)
            });

            cardFullscreen.addEventListener("click", function() {
                animateFullscreen(cardFullscreen, card);
                setTimeout(() => {
                    // root.classList.remove('no-overflow'); // with this the page is slightly resized and the header menu is shown
                    card.classList.remove('card-visible');
                    cardFullscreen.classList.remove('card-fullscreen-visible');
                }, 500)
            });
        }

        function animateFullscreen(fromHero, toHero) {

            let clone = fromHero.cloneNode(true);

            let from = calculatePosition(fromHero);
            let to = calculatePosition(toHero);

            gsap.set([fromHero, toHero], { visibility: "hidden" });
            gsap.set(clone, { position: "absolute", margin: 0 });

            body.appendChild(clone);

            let style = {
                x: to.left - from.left,
                y: to.top - from.top,
                width: to.width,
                height: to.height,
                autoRound: false,
                duration: 0.5,
                ease: "power2.inOut",
                onComplete: onComplete
            };

            gsap.set(clone, from);
            gsap.to(clone, style)

            function onComplete() {
                gsap.set(toHero, { visibility: "visible" });
                body.removeChild(clone);
            }
        }

        function calculatePosition(element) {

            let rect = element.getBoundingClientRect();

            let scrollTop  = window.pageYOffset || root.scrollTop  || body.scrollTop  || 0;
            let scrollLeft = window.pageXOffset || root.scrollLeft || body.scrollLeft || 0;

            let clientTop  = root.clientTop  || body.clientTop  || 0;
            let clientLeft = root.clientLeft || body.clientLeft || 0;

            return {
                top: Math.round(rect.top + scrollTop - clientTop),
                left: Math.round(rect.left + scrollLeft - clientLeft),
                height: rect.height,
                width: rect.width,
            };
        }
    }

    return {
        init: init
    }

})(jQuery);